import {useFormContext} from "react-hook-form";

import {CodeBlock} from "@/components/codeBlock/CodeBlock.tsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {CheckFormInfo} from "@/pages/checks/components/form/CheckFormInfo.tsx";
import {RUM_SNIPPET_PLACEMENT_HINT} from "@/pages/checks/constants.ts";
import {buildRumSnippet} from "@/pages/checks/utils.ts";

interface RUMSnippetProps {
  uuid: string;
  title: string;
  snippet: string;
  externalDomains?: string;
  isAjaxDisabled?: boolean;
  onModal?: boolean;
}

export const RUMSnippet = ({uuid, title, snippet, externalDomains, isAjaxDisabled, onModal}: RUMSnippetProps) => {
  const context = useFormContext();
  const resolvedExternalDomains =
    externalDomains === undefined ? context.watch(ServiceField.RUM_EXTERNAL_DOMAINS) : externalDomains;
  const resolvedIsAjaxDisabled =
    isAjaxDisabled === undefined ? context.watch(ServiceField.RUM_IS_AJAX_DISABLED) : isAjaxDisabled;
  const code = buildRumSnippet(snippet, uuid, resolvedExternalDomains, resolvedIsAjaxDisabled);

  return (
    <>
      {!onModal && <div className="pulseTextH3Bold mb-4 mt-4 pt-2">{title}</div>}
      <div className="mb-3">
        <CheckFormInfo title={RUM_SNIPPET_PLACEMENT_HINT} />
        <div className="pulseTextBody mt-2">
          This will enable RUM Checks on all pages where this snippet appears. It will not affect your site's page load
          time.
        </div>
      </div>
      <CodeBlock code={code} onModal={onModal} />
      {onModal && (
        <div className="pulseTextBody mt-3">
          Note: Your {title.split(" ").slice(0, 2).join(" ")} can be permanently found in the{" "}
          <span className="pulseTextBodyBold">General</span> tab.
        </div>
      )}
    </>
  );
};
